__turbopack_context__.v({
  "address": "FooterMenuItem-module-scss-module__K-dZkW__address",
  "addressLink": "FooterMenuItem-module-scss-module__K-dZkW__addressLink",
  "aiBadge": "FooterMenuItem-module-scss-module__K-dZkW__aiBadge",
  "link": "FooterMenuItem-module-scss-module__K-dZkW__link",
  "linkText": "FooterMenuItem-module-scss-module__K-dZkW__linkText",
  "list": "FooterMenuItem-module-scss-module__K-dZkW__list",
  "root": "FooterMenuItem-module-scss-module__K-dZkW__root",
  "text": "FooterMenuItem-module-scss-module__K-dZkW__text",
  "title": "FooterMenuItem-module-scss-module__K-dZkW__title",
});
